/**
 * Gemeinsame Normalisierung für Kassen-Speicher (Legacy + NewCashRegister).
 * Verhindert `.filter` auf undefined bei alten KV-Einträgen.
 */

export function createEmptyNewCashRegisterData(businessId) {
  return {
    businessId,
    createdAt: new Date().toISOString(),
    lastUpdated: new Date().toISOString(),
    sessions: [],
    activeSession: null,
    settings: {
      currency: 'MRO',
      allowNegativeAmounts: false,
      requireExplanationForDeviation: true,
      deviationThreshold: 0.01
    },
    statistics: {
      totalSessions: 0,
      totalTransactions: 0,
      totalCashHandled: 0,
      averageDeviation: 0,
      lastSessionDate: null
    }
  };
}

export function normalizeNewCashRegisterData(data, businessId) {
  const defaults = createEmptyNewCashRegisterData(businessId);
  const merged = {
    ...defaults,
    ...data,
    businessId: data?.businessId ?? businessId ?? defaults.businessId,
    settings: { ...defaults.settings, ...(data?.settings || {}) },
    statistics: { ...defaults.statistics, ...(data?.statistics || {}) }
  };
  merged.sessions = Array.isArray(data?.sessions) ? data.sessions : [];
  merged.activeSession =
    data?.activeSession && typeof data.activeSession === 'object' ? data.activeSession : null;
  return merged;
}

/** Legacy-Struktur: cashRegisterService (`cashRegisterData_<id>`). */
export function createEmptyLegacyCashRegisterData() {
  return {
    sessions: [],
    activeSession: null,
    lastUpdated: new Date().toISOString()
  };
}

export function normalizeLegacyCashRegisterData(data) {
  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    return createEmptyLegacyCashRegisterData();
  }
  return {
    ...data,
    sessions: Array.isArray(data.sessions) ? data.sessions : [],
    activeSession:
      data.activeSession && typeof data.activeSession === 'object' ? data.activeSession : null,
    lastUpdated: data.lastUpdated ?? new Date().toISOString()
  };
}

export function isCorruptedKvString(value) {
  return (
    typeof value === 'string' &&
    (value === '[object Object]' || value === '"[object Object]"' || value.trim() === '')
  );
}

export function parseKvObject(value) {
  if (value == null) return null;
  if (typeof value === 'string') {
    if (isCorruptedKvString(value)) return { corrupted: true, data: null };
    try {
      return { corrupted: false, data: JSON.parse(value) };
    } catch {
      return { corrupted: true, data: null };
    }
  }
  if (typeof value === 'object') return { corrupted: false, data: value };
  return { corrupted: true, data: null };
}
